export function count(a, test) {
    return a.reduce((accumulator, el) => (test(el) ? accumulator + 1 : accumulator), 0);
}
export function sortBy(a, field, asc = true) {
    a.sort((e1, e2) => (e1[field] < e2[field] ? (asc ? -1 : 1) : e1[field] > e2[field] ? (asc ? 1 : -1) : 0));
}
export function mergeSortedBy(a, b, field, asc = true) {
    if (a.length === 0) {
        return [...b];
    }
    if (b.length === 0) {
        return [...a];
    }
    const merged = [];
    const undef = [];
    // Merge until one array runs out of stuff
    let ai = 0;
    let bi = 0;
    while (ai < a.length && bi < b.length) {
        // Pick the smaller among the smallest element of left and right sub arrays
        if (a[ai][field] === undefined) {
            undef.push(a[ai]);
            ai++;
        }
        else if (b[bi][field] === undefined) {
            undef.push(b[bi]);
            bi++;
        }
        else if ((asc && a[ai][field] < b[bi][field]) || (!asc && a[ai][field] > b[bi][field])) {
            merged.push(a[ai]);
            ai++;
        }
        else {
            merged.push(b[bi]);
            bi++;
        }
    }
    // Add whatever is left.  At most this will be one of the arrays.
    for (; ai < a.length; ai++) {
        merged.push(a[ai]);
    }
    for (; bi < b.length; bi++) {
        merged.push(b[bi]);
    }
    // finally add anything that had the field undefined
    for (let i = 0; i < undef.length; i++) {
        merged.push(undef[i]);
    }
    return merged;
}
export function maxBy(a, field) {
    if (a.length === 0) {
        return null;
    }
    else {
        let max = null;
        for (let i = 0; i < a.length; i++) {
            if (a[i][field] && (max === null || (a[i][field] > max[field]))) {
                max = a[i];
            }
        }
        return max;
    }
}
//# sourceMappingURL=arrays.js.map